import React, {useEffect} from 'react';
import EntityViewProp from './properties/entity-view';
import {EntityTypeEnum} from '../enums/EntityTypeEnum';
import {StatusMessageTypeEnum} from "../enums/StatusMessageTypeEnum";

function EntityView({
                        setStatusMessage, data, id,
                    }: EntityViewProp): React.ReactElement {
    useEffect(() => {
        setStatusMessage('', StatusMessageTypeEnum.none);
    }, []);

    const color = (data.type !== EntityTypeEnum.brother && data.type !== EntityTypeEnum.joined) ? '#cbf1ff' : '#d1ffe8';

    return (
        <div className="pb-2">
            <a
                data-bs-toggle="collapse"
                aria-expanded="false"
                href={`#${id}`}
                key={id}
                role="button"
                aria-controls={id}
                className="row p-2 rounded-top not-link"
                style={{backgroundColor: color}}
            >
                <div className="col ps-1 normal-text-italic">
                    {
                        // eslint-disable-next-line no-nested-ternary
                        data.type === EntityTypeEnum.brother
                            ? (
                                <div className="d-inline">
                                    <span className="pe-1"><strong>Brother:</strong></span>
                                    <span className="pe-1">
                    <strong>
                      (Triplet Id : &nbsp;
                        {data.triplet.id}
                        )
                    </strong>
                  </span>
                                    <span>
                    {data.connectingVerbConcept?.id}
                  </span>
                                    <span className="pe-1 ps-1">/</span>
                                    <span>{data.connectingVerbConcept?.shortname}</span>
                                </div>
                            )
                            : (
                                data.type === EntityTypeEnum.joined ? (
                                    <div className="d-inline">
                                        <span className="pe-1"><strong>Joined:</strong></span>
                                        <span className="pe-1">
                      <strong>
                        (Triplet Id : &nbsp;
                          {data.triplet.id}
                          )
                      </strong>
                    </span>
                                        <span>
                      {data.connectingVerbConcept?.id}
                    </span>
                                        <span className="pe-1 ps-1">/</span>
                                        <span>{data.connectingVerbConcept?.shortname}</span>
                                    </div>
                                ) : (
                                    <span className="pe-1">
                    <strong>
                      <span> Entity </span>
                      <span>
                        (Triplet Id : &nbsp;
                          {data.triplet.id}
                          )
                      </span>
                    </strong>
                  </span>
                                )
                            )
                    }
                </div>
                <div className="col ps-1 normal-text-italic">
                    <span className=""><strong>{data.verb}</strong></span>
                </div>
                <div className="col normal-text-italic">
                    <span className="pe-1"><strong>Target:</strong></span>
                    <span>{data.target}</span>
                </div>
            </a>
            <div className="row collapse" id={id} style={{backgroundColor: '#ecfaff'}}>
                <div className="col-12 pb-2">
                    <div className="row">
                        <div className="col-12 p-2" style={{backgroundColor: '#efefef'}}>
                            {data.references?.map((item) => (
                                <div className="row" key={item.key}>
                                    <div className="col-12 ps-3 pt-2">
                    <span className="normal-text-italic pe-1">
                      {item.key}
                        :
                    </span>
                                        <span className="pe-1">{item.value}</span>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-4 ps-3 pt-2">
              <span className="normal-text-italic pe-1">
                Subject Id
                :
              </span>
                            <span className="pe-1">
                {' '}
                                {data.triplet?.subject?.id}
              </span>
                        </div>
                        <div className="col-4 ps-3 pt-2">
              <span className="normal-text-italic pe-1">
                code
                :
              </span>
                            <span className="pe-1">
                {' '}
                                {data.triplet?.subject?.code}
              </span>
                        </div>
                        <div className="col-4 ps-3 pt-2">
              <span className="normal-text-italic pe-1">
                shortname
                :
              </span>
                            <span className="pe-1">
                {' '}
                                {data.triplet?.subject?.shortname}
              </span>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-4 ps-3 pt-2">
              <span className="normal-text-italic pe-1">
                Verb Id
                :
              </span>
                            <span className="pe-1">
                {' '}
                                {data.triplet?.verb?.id}
              </span>
                        </div>
                        <div className="col-4 ps-3 pt-2">
              <span className="normal-text-italic pe-1">
                code
                :
              </span>
                            <span className="pe-1">
                {' '}
                                {data.triplet?.verb?.code}
              </span>
                        </div>
                        <div className="col-4 ps-3 pt-2">
              <span className="normal-text-italic pe-1">
                shortname
                :
              </span>
                            <span className="pe-1">
                {' '}
                                {data.triplet?.verb?.shortname}
              </span>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-4 ps-3 pt-2">
              <span className="normal-text-italic pe-1">
                Target Id
                :
              </span>
                            <span className="pe-1">
                {' '}
                                {data.triplet?.target?.id}
              </span>
                        </div>
                        <div className="col-4 ps-3 pt-2">
              <span className="normal-text-italic pe-1">
                code
                :
              </span>
                            <span className="pe-1">
                {' '}
                                {data.triplet?.target?.code}
              </span>
                        </div>
                        <div className="col-4 ps-3 pt-2">
              <span className="normal-text-italic pe-1">
                shortname
                :
              </span>
                            <span className="pe-1">
                {' '}
                                {data.triplet?.target?.shortname}
              </span>
                        </div>
                    </div>
                </div>
                <div/>
            </div>
        </div>
    );
}

export default EntityView;
